import { TSpecProjectType } from '../types/developer/specProject';

export function isFsk(specProjectType?: TSpecProjectType | null) {
  if (!specProjectType) {
    return false;
  }

  return specProjectType === 'fsk';
}
